module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain.3c312dfc.svg";